import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectUserRoleId,
} from "../../store/selectors/authSelectors";
import { getPostLoginRoute } from "../../utils/routeUtils";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute - redirects to the user's home page if already authenticated.
 * Used for login, registration, and other auth pages.
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userRoleId = useSelector(selectUserRoleId);

  if (isAuthenticated) {
    return <Navigate to={getPostLoginRoute(userRoleId)} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
